import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const store = createStore({
  state: {
    orderData: {}, // Состояние для хранения orderData
  },
  mutations: {
    // SET_ORDER_DATA(state, payload) {
    //   state.orderData = payload; // Изменяем состояние на переданный объект
    // },

    SET_ORDER_DATA(state, { key, data }) {
      state.orderData[key] = {
        data: data,
        timestamp: Date.now(), // Сохраняем текущее время
      };
    },
    REMOVE_EXPIRED_ORDER_DATA(state) {
      const now = Date.now();
      for (const key in state.orderData) {
        if (now - state.orderData[key].timestamp > 24 * 60 * 60 * 1000) { // 24 часа
          delete state.orderData[key]; // Удаляем устаревшие данные
        }
      }
    },
  },
  getters: {
    getOrderData(state) {
      return state.orderData; // Геттер для получения orderData
    },
    getOrderDataByKey(state) {
      return (key) => state.orderData[key] ? state.orderData[key].data : null;
    },
  },
  plugins: [createPersistedState()], // Добавляем плагин
});

export default store;